export const TOP_CHART_CARD_HEIGHT = 360;
export const BOTTOM_CHART_CARD_HEIGHT = 380;

export const dashboardTokens = {
  cardBg: '#181818',
  border: '#2c2c2c',
  borderSubtle: '#313131',
  textPrimary: '#fff',
  textSecondary: '#8A8D91',
  textMuted: '#86878c',
  controlBg: '#232323',
  ghostBar: '#2a2a2a',
  ghostBarHover: '#333',
  accent: '#FF5B5B',
  income: '#ffffff',
  expense: '#6b6b6b',
  cardRadius: '16px',
};

export const chartCardSx = (height: number) => ({
  bgcolor: dashboardTokens.cardBg,
  borderRadius: dashboardTokens.cardRadius,
  height,
  width: '100%',
  boxSizing: 'border-box' as const,
  display: 'flex',
  flexDirection: 'column' as const,
  overflow: 'hidden',
  px: 2.5,
  py: 2.25,
});

export const cardHeaderSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 1,
  flexShrink: 0,
};

export const cardTitleSx = {
  fontWeight: 700,
  fontSize: 20,
  color: dashboardTokens.textPrimary,
  lineHeight: 1.2,
  letterSpacing: '-0.01em',
};

export const cardSubtitleSx = {
  fontSize: 12,
  color: dashboardTokens.textSecondary,
  mt: 0.35,
  lineHeight: 1.4,
};

export const cardStatSx = {
  fontSize: 11,
  color: dashboardTokens.textMuted,
  mt: 0.5,
  fontWeight: 500,
};

export const cardBodySx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column' as const,
  justifyContent: 'center',
};

export const cardDividerSx = {
  borderTop: `1px solid ${dashboardTokens.borderSubtle}`,
  mt: 1.75,
  pt: 2,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
};

export const dropdownSx = {
  display: 'flex',
  alignItems: 'center',
  bgcolor: dashboardTokens.controlBg,
  border: `1px solid ${dashboardTokens.borderSubtle}`,
  borderRadius: '8px',
  px: 1.25,
  py: 0.45,
  fontSize: 12,
  color: dashboardTokens.textPrimary,
  fontWeight: 600,
  cursor: 'pointer',
  gap: 0.25,
  flexShrink: 0,
  userSelect: 'none' as const,
  transition: 'border-color 0.2s, background-color 0.2s',
  '&:hover': {
    borderColor: '#444',
    bgcolor: '#2a2a2a',
  },
};

export const checkboxControlSx = {
  p: 0.5,
  '&.Mui-checked': { color: dashboardTokens.accent },
};

export const checkboxLabelSx = {
  m: 0,
  gap: 0.5,
  '& .MuiFormControlLabel-label': {
    fontSize: 13,
    fontWeight: 600,
    color: '#bbb',
    lineHeight: 1,
  },
};

export const bottomCardSx = {
  bgcolor: dashboardTokens.cardBg,
  borderRadius: dashboardTokens.cardRadius,
  height: BOTTOM_CHART_CARD_HEIGHT,
  width: '100%',
  boxSizing: 'border-box' as const,
  display: 'flex',
  flexDirection: 'column' as const,
  overflow: 'hidden',
  px: 2.5,
  py: 2.25,
};

export const chartTooltipProps = {
  arrow: true,
  placement: 'top' as const,
  enterDelay: 200,
  leaveDelay: 0,
  slotProps: {
    tooltip: {
      sx: {
        bgcolor: '#2a2a2a',
        border: '1px solid #3a3a3a',
        borderRadius: '8px',
        px: 1.5,
        py: 1,
        fontSize: 12,
        fontWeight: 500,
        boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
        maxWidth: 220,
      },
    },
    arrow: {
      sx: { color: '#2a2a2a', '&::before': { border: '1px solid #3a3a3a' } },
    },
  },
};

export const ghostBarSx = (height: number | string, width: number | string = '100%') => ({
  width,
  height,
  bgcolor: dashboardTokens.ghostBar,
  borderRadius: '8px',
  position: 'relative' as const,
  overflow: 'hidden',
  flexShrink: 0,
});

export const filledBarSx = (
  height: number | string,
  color: string,
  width: number | string = '100%',
) => ({
  position: 'absolute' as const,
  bottom: 0,
  left: 0,
  width,
  height,
  bgcolor: color,
  borderRadius: '8px',
  transition: 'height 0.35s ease',
});
